module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-left-7f6ebea71f9ab443ccc953ce915f8e12.svg";